module.exports = __webpack_public_path__ + "static/media/content-onboarding_04.681f52f5.png";